import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Update.module.sass";
import Icon from "../../../../../../components/Icon";
import TextInput from "../../../../../../components/TextInput";
import {
  update_tags_barcode,
  get_one_tags_barcode,
} from "../../../../../../API/TagBarcode";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { message } from "antd";
import Card from "../../../../../../components/Card";
import { useNavigate, useParams } from "react-router";
import Panel from "../Panel";

const UpdateBarcode = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState({
    barcode: "",
    tag_name: "",
  });

  useEffect(() => {
    const fetchBarcodeDetails = async () => {
      try {
        const response = await get_one_tags_barcode(id);
        const barcodeDetails = response.data;
        setInitialValues({
          barcode: barcodeDetails.barcode,
          tag_name: barcodeDetails.tag_name,
        });
      } catch (error) {
        message.error("Failed to fetch barcode details.");
        navigate("/");
      }
    };

    fetchBarcodeDetails();
  }, [id]);

  const validationSchema = Yup.object({
    barcode: Yup.string().required("Barcode is required"),
    tag_name: Yup.string().required("Tag name is required"),
  });

  const handleSave = async (
    values,
    { setTouched, setErrors, validateForm }
  ) => {
    try {
      const errors = await validateForm();
      if (Object.keys(errors).length > 0) {
        setTouched({
          tag_name: true,
          barcode: true,
        });
        setErrors(errors);
        return;
      }

      const formData = {
        id,
        ...values,
      };

      const res = await update_tags_barcode(formData);
      if (res.status === 201) {
        message.success(res.data.message);
        navigate("/settingsDashboard/camera&Barcode/actionBarcodesForTag");
      }
    } catch (error) {
      if (error.response?.status === 400) {
        message.error(Object.values(error.response.data.errors[0])[0]);
      } else {
        message.error("An error occurred while updating the barcode");
      }
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleSave}
    >
      {({ isSubmitting }) => (
        <Form>
          <Card
            className={cn(styles.card)}
            title="Edit Action Barcode for Tags"
            classTitle="title-red"
            head={
              <button
                className={cn("button-stroke")}
                onClick={() =>
                  navigate(
                    "/settingsDashboard/camera&Barcode/actionBarcodesForTag"
                  )
                }
              >
                <Icon name="arrow-left" size="24" />
                <span>Back</span>
              </button>
            }
          >
            <div className={styles.description}>
              <Field name="barcode">
                {({ field, meta }) => (
                  <TextInput
                    {...field}
                    label="Enter Barcode"
                    className={cn(styles.field)}
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                    disabled
                  />
                )}
              </Field>
              <Field name="tag_name">
                {({ field, meta }) => (
                  <TextInput
                    {...field}
                    label="Enter Tag"
                    className={cn(styles.field)}
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                  />
                )}
              </Field>
            </div>
            <div className="fixed bottom-7 left-30 right-5">
              <Panel />
            </div>
          </Card>
        </Form>
      )}
    </Formik>
  );
};
export default UpdateBarcode;
